export abstract class StringUtils {
	public static isNullOrEmpty(value: string | null | undefined): boolean {
		return value === null || value === undefined || value.trim?.() === "";
	}

	public static isNotNullOrEmpty(value: string | null | undefined): boolean {
		return value !== null && value !== undefined && value.trim?.() !== "";
	}
}

function capitalize(str: string): string {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

function sanitizeCpfCnpj(input: string): string {
	return input.replace(/[^0-9]/g, "");
}

function formatCompanyTaxpayerRegistration(
	companyTaxpayerRegistration: string
): string {
	return companyTaxpayerRegistration.length >= 14
		? sanitizeCpfCnpj(companyTaxpayerRegistration)
		: "";
}

function unmaskCpfCnpj(cpfCnpj: string): string {
	return sanitizeCpfCnpj(cpfCnpj);
}

export { capitalize, formatCompanyTaxpayerRegistration, unmaskCpfCnpj };
